import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type {
  FetchManagerListParams,
  ManagerListResponse,
  PostCancelManagerParams,
  PostCancelManagerResponse,
  PostWriteManagerParams,
  PostWriteManagerResponse,
} from './type';

export const fetchManagerList = async (params: FetchManagerListParams) => {
  const res = await fetchExtended(`/v1/manager/index`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ManagerListResponse;
};

export const postCancelManager = async (postCancelManagerParams: PostCancelManagerParams) => {
  const res = await fetchExtended(`/v1/manager/cancel`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(postCancelManagerParams),
  });

  const result = await res.json();

  return result as PostCancelManagerResponse;
};

export const postWriteManager = async (postWriteManagerParams: PostWriteManagerParams) => {
  const res = await fetchExtended(`/v1/manager/write`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(postWriteManagerParams),
  });

  const result = await res.json();

  return result as PostWriteManagerResponse;
};
